import React, { useState } from "react";

const SEVERITY_COLOR = {
  Critical: { dot: "#e24b4a", bg: "#fef2f2", text: "#a32d2d" },
  High:     { dot: "#ba7517", bg: "#faeeda", text: "#633806" },
  Medium:   { dot: "#1a9e78", bg: "#e1f5ee", text: "#0f6e56" },
};

const SectionHeader = ({ icon, title }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 8 }}>
    {icon}
    <span style={{ fontSize: 13, fontWeight: 500, color: "#1a1e2e" }}>{title}</span>
  </div>
);

// const TelemetryTable = ({ rows }) => (
//   <div style={{ overflowX: "auto" }}>
//     <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11.5 }}>
//       <thead>
//         <tr style={{ background: "#f5f6f8" }}>
//           {["VesselTime", "Cyl 1 Jacket Cooling Water Outlet Temp High", "Exhaust Ga"].map(h => (
//             <th key={h} style={{ padding: "6px 10px", textAlign: "left", color: "#8a909e",
//               fontWeight: 500, borderBottom: "0.5px solid #e2e4e8", whiteSpace: "nowrap" }}>{h}</th>
//           ))}
//         </tr>
//       </thead>
//       <tbody>
//         {rows.map((r, i) => (
//           <tr key={i}>
//             <td style={{ padding: "6px 10px", color: "#5a6070", borderBottom: "0.5px solid #f0f1f3" }}>{r.vesselTime}</td>
//             <td style={{ padding: "6px 10px", color: "#1a1e2e", fontWeight: 500, borderBottom: "0.5px solid #f0f1f3" }}>{r.cyl1TempHigh}</td>
//             <td style={{ padding: "6px 10px", color: "#1a1e2e", borderBottom: "0.5px solid #f0f1f3" }}>{r.exhaustGas}</td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// );



// Replace the hardcoded TelemetryTable component with this:
const TelemetryTable = ({ rows, columns }) => {
  const cols = columns || ["VesselTime", "Cyl 1 Jacket Cooling Water Outlet Temp High", "Exhaust Ga"];
  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11.5 }}>
        <thead>
          <tr style={{ background: "#f5f6f8" }}>
            {cols.map(h => (
              <th key={h} style={{
                padding: "6px 10px", textAlign: "left", color: "#8a909e",
                fontWeight: 500, borderBottom: "0.5px solid #e2e4e8", whiteSpace: "nowrap",
              }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              {cols.map((col, j) => (
                <td key={j} style={{
                  padding: "6px 10px", color: j === 0 ? "#5a6070" : "#1a1e2e",
                  fontWeight: j > 0 ? 500 : 400,
                  borderBottom: "0.5px solid #f0f1f3",
                }}>
                  {r[j] ?? ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
const RiskTriggerCard = ({ card }) => {
  const [action,       setAction]      = useState(null); // "Accept"|"Defer"|"Reject"
  const [reason,       setReason]      = useState("");
  const [comment,      setComment]     = useState("");
  const [assignOpen,   setAssignOpen]  = useState(false);
  const [submitted,    setSubmitted]   = useState(false);
  const [errors,       setErrors]      = useState({});

  const sev = SEVERITY_COLOR[card.severity] || SEVERITY_COLOR.High;

  const handleActionClick = (a) => {
    setAction(prev => prev === a ? null : a);
    setErrors({});
  };

  const handleSubmit = () => {
    const e = {};
    if ((action === "Defer" || action === "Reject") && !reason.trim())
      e.reason = "Reason is required for Defer / Reject";
    if (action === "Accept" && !comment.trim())
      e.comment = "Comment is required for Accept";
    if (Object.keys(e).length) { setErrors(e); return; }
    setSubmitted(true);
  };

  const S = {
    card: {
      background: "#fff", border: "0.5px solid #e2e4e8",
      borderRadius: 10, marginBottom: 14, overflow: "hidden",
    },
    cardInner: { padding: "16px 18px" },
    divider: { borderTop: "0.5px solid #e2e4e8", margin: "14px 0" },
    twoCol: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 },
    body: { fontSize: 12.5, color: "#5a6070", lineHeight: 1.7, whiteSpace: "pre-line" },
    chip: (label) => {
      const map = { Equipment: { bg: "#f0f1f3", color: "#5a6070" }, Port: { bg: "#e1f5ee", color: "#0f6e56" } };
      const s = map[label] || map.Equipment;
      return { fontSize: 11, padding: "3px 10px", borderRadius: 20, background: s.bg, color: s.color,
        fontWeight: 500, display: "inline-flex", alignItems: "center", gap: 4 };
    },
    actionBtn: (active, type) => {
      const styles = {
        Accept: { active: { bg: "#1a9e78", color: "#fff", border: "#1a9e78" }, idle: { bg: "#fff", color: "#1a9e78", border: "#1a9e78" } },
        Defer:  { active: { bg: "#ba7517", color: "#fff", border: "#ba7517" }, idle: { bg: "#fff", color: "#ba7517", border: "#ba7517" } },
        Reject: { active: { bg: "#e24b4a", color: "#fff", border: "#e24b4a" }, idle: { bg: "#fff", color: "#e24b4a", border: "#e24b4a" } },
        Assign: { active: { bg: "#5a6070", color: "#fff", border: "#5a6070" }, idle: { bg: "#fff", color: "#5a6070", border: "#e2e4e8" } },
      };
      const s = (styles[type] || styles.Assign)[active ? "active" : "idle"];
      return {
        height: 34, padding: "0 16px", borderRadius: 6,
        border: `0.5px solid ${s.border}`, background: s.bg, color: s.color,
        fontSize: 12.5, fontWeight: 500, cursor: "pointer",
        display: "flex", alignItems: "center", gap: 5,
      };
    },
  };

  if (submitted) {
    return (
      <div style={{ ...S.card }}>
        <div style={{ ...S.cardInner, textAlign: "center", padding: "30px 18px" }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>✓</div>
          <div style={{ fontSize: 14, fontWeight: 500, color: "#1a9e78" }}>
            Card {action}ed successfully
          </div>
          <div style={{ fontSize: 12, color: "#8a909e", marginTop: 4 }}>{card.title}</div>
          <button onClick={() => { setSubmitted(false); setAction(null); setReason(""); setComment(""); }}
            style={{ marginTop: 14, ...S.actionBtn(false, "Assign") }}>
            Undo
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={S.card}>
      <div style={S.cardInner}>

        {/* ── Header ─────────────────────────────────────────── */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", background: sev.dot, display: "inline-block" }} />
              <span style={{ fontSize: 11.5, fontWeight: 600, color: sev.text,
                background: sev.bg, padding: "2px 8px", borderRadius: 20 }}>
                {card.severity}
              </span>
            </div>
            <span style={{ color: "#e2e4e8" }}>|</span>
            <span style={{ fontSize: 14, fontWeight: 500, color: "#1a1e2e" }}>{card.title}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11.5, color: "#8a909e" }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            {card.date}
          </div>
        </div>

        {/* Chips */}
        <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
          <span style={S.chip("Equipment")}>Equipment Name: {card.equipmentName}</span>
          <span style={S.chip("Equipment")}>Equipment ID: {card.equipmentId}</span>
          <span style={S.chip("Port")}>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            Recommended Port: {card.recommendedPort}
          </span>
        </div>

        {/* ── Summary ────────────────────────────────────────── */}
        <SectionHeader
          title="Summary"
          icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#556ee6" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>}
        />
        <p style={S.body}>{card.summary}</p>

        <div style={S.divider} />

        {/* ── Trigger Condition + Telemetry Evidence ─────────── */}
        <div style={S.twoCol}>
          <div>
            <SectionHeader
              title="Trigger Condition"
              icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>}
            />
            <code style={{ fontSize: 11.5, color: "#5a6070", background: "#f5f6f8",
              padding: "8px 10px", borderRadius: 6, display: "block", lineHeight: 1.6 }}>
              {card.triggerCondition}
            </code>
          </div>
          <div>
            <SectionHeader
              title="Telemetry Evidence"
              icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1a9e78" strokeWidth="2">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
              </svg>}
            />
          <TelemetryTable rows={card.telemetry} columns={card.telemetryColumns} />
          </div>
        </div>

        <div style={S.divider} />

        {/* ── Maintenance Intelligence ─────────────────────── */}
        <SectionHeader
          title="Maintenance Intelligence"
          icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.07 4.93l-1.41 1.41M4.93 19.07l1.41-1.41M19.07 19.07l-1.41-1.41M4.93 4.93l1.41 1.41M12 2v2M12 20v2M2 12h2M20 12h2"/>
          </svg>}
        />
        <p style={S.body}>{card.maintenanceIntelligence}</p>

        <div style={S.divider} />

        {/* ── Recommended Action ───────────────────────────── */}
        <SectionHeader
          title="Recommended Action"
          icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1a9e78" strokeWidth="2">
            <polyline points="9 11 12 14 22 4"/>
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
          </svg>}
        />
        <p style={S.body}>{card.recommendedAction}</p>

        <div style={S.divider} />

        {/* ── Report Insights + Voyage Recommendation ──────── */}
        <div style={S.twoCol}>
          <div>
            <SectionHeader
              title="Report Insights"
              icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#185fa5" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
                <polyline points="10 9 9 9 8 9"/>
              </svg>}
            />
            <p style={S.body}>{card.reportInsights}</p>
          </div>
          <div>
            <SectionHeader
              title="Voyage Recommendation"
              icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0f6e56" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15 15 0 0 1 4 10 15 15 0 0 1-4 10 15 15 0 0 1-4-10 15 15 0 0 1 4-10z"/>
              </svg>}
            />
            <p style={S.body}>{card.voyageRecommendation}</p>
          </div>
        </div>

        <div style={S.divider} />

        {/* ── Action buttons ───────────────────────────────── */}
        <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
          <button style={S.actionBtn(action === "Accept", "Accept")} onClick={() => handleActionClick("Accept")}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            Accept
          </button>
          <button style={S.actionBtn(action === "Defer", "Defer")} onClick={() => handleActionClick("Defer")}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            Defer
          </button>
          <button style={S.actionBtn(action === "Reject", "Reject")} onClick={() => handleActionClick("Reject")}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
            Reject
          </button>
          <div style={{ position: "relative" }}>
            <button style={S.actionBtn(assignOpen, "Assign")} onClick={() => setAssignOpen(o => !o)}>
              Assign
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            {assignOpen && (
              <div style={{
                position: "absolute", top: "110%", left: 0, background: "#fff",
                border: "0.5px solid #e2e4e8", borderRadius: 8, zIndex: 10,
                boxShadow: "0 4px 12px rgba(0,0,0,.08)", minWidth: 160, overflow: "hidden",
              }}>
                {["Chief Engineer", "Second Engineer", "ETO"].map(r => (
                  <div key={r}
                    onClick={() => setAssignOpen(false)}
                    style={{ padding: "9px 14px", fontSize: 12, color: "#1a1e2e", cursor: "pointer" }}
                    onMouseEnter={e => e.currentTarget.style.background = "#f5f6f8"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                  >
                    {r}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ── Defer/Reject Reason + Comments ──────────────── */}
        {action && (
          <div style={{
            background: "#f5f6f8", borderRadius: 8,
            padding: "14px 16px", border: "0.5px solid #e2e4e8",
          }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>

              {/* Reason */}
              <div>
                <label style={{ fontSize: 12, fontWeight: 500, color: "#1a1e2e",
                  display: "block", marginBottom: 6 }}>
                  Defer / Reject Reason
                  {(action === "Defer" || action === "Reject") && (
                    <span style={{ color: "#e24b4a", marginLeft: 2 }}>*</span>
                  )}
                </label>
                <textarea
                  value={reason}
                  onChange={e => { setReason(e.target.value); setErrors(p => ({ ...p, reason: "" })); }}
                  placeholder={action === "Accept"
                    ? "Not required for Accept"
                    : "Required only if Defer or Reject is selected"}
                  disabled={action === "Accept"}
                  style={{
                    width: "100%", minHeight: 80, padding: "8px 10px",
                    border: `0.5px solid ${errors.reason ? "#e24b4a" : "#e2e4e8"}`,
                    borderRadius: 6, fontSize: 12, color: "#1a1e2e",
                    background: action === "Accept" ? "#eeeff1" : "#fff",
                    resize: "vertical", outline: "none", fontFamily: "inherit",
                    lineHeight: 1.6, boxSizing: "border-box",
                  }}
                />
                {errors.reason && (
                  <div style={{ fontSize: 11, color: "#e24b4a", marginTop: 3 }}>{errors.reason}</div>
                )}
              </div>

              {/* Comments */}
              <div>
                <label style={{ fontSize: 12, fontWeight: 500, color: "#1a1e2e",
                  display: "block", marginBottom: 6 }}>
                  Comments
                  {action === "Accept" && (
                    <span style={{ color: "#e24b4a", marginLeft: 2 }}>*</span>
                  )}
                </label>
                <textarea
                  value={comment}
                  onChange={e => { setComment(e.target.value); setErrors(p => ({ ...p, comment: "" })); }}
                  placeholder="Type here"
                  style={{
                    width: "100%", minHeight: 80, padding: "8px 10px",
                    border: `0.5px solid ${errors.comment ? "#e24b4a" : "#e2e4e8"}`,
                    borderRadius: 6, fontSize: 12, color: "#1a1e2e",
                    background: "#fff", resize: "vertical", outline: "none",
                    fontFamily: "inherit", lineHeight: 1.6, boxSizing: "border-box",
                  }}
                />
                {errors.comment && (
                  <div style={{ fontSize: 11, color: "#e24b4a", marginTop: 3 }}>{errors.comment}</div>
                )}
              </div>
            </div>

            {/* Submit */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
              <button
                onClick={handleSubmit}
                style={{
                  height: 34, padding: "0 20px", borderRadius: 6,
                  border: "none", background: "#1a9e78", color: "#fff",
                  fontSize: 12.5, fontWeight: 500, cursor: "pointer",
                  display: "flex", alignItems: "center", gap: 6,
                }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.5">
                  <line x1="22" y1="2" x2="11" y2="13"/>
                  <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                </svg>
                Submit
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default RiskTriggerCard;